var map = {
	"./icon-package-3g-light.svg": 836,
	"./icon-package-4g-light.svg": 837,
	"./icon-package-5g-light.svg": 838,
	"./icon-package-activation-policy-light.svg": 839,
	"./icon-package-arrow-general-light.svg": 840,
	"./icon-package-calling-credit-light.svg": 841,
	"./icon-package-coverage-light.svg": 842,
	"./icon-package-ekyc-micro-light.svg": 843,
	"./icon-package-ekyc-restriction-light.svg": 844,
	"./icon-package-ekyc-validation-light.svg": 845,
	"./icon-package-fup-light.svg": 846,
	"./icon-package-info-general-light.svg": 847,
	"./icon-package-lte-light.svg": 848,
	"./icon-package-network-light.svg": 849,
	"./icon-package-plan-type-light.svg": 850,
	"./icon-package-price-light.svg": 851,
	"./icon-package-supported-arrow-light.svg": 852,
	"./icon-package-topup-option-light.svg": 853,
	"./icon-package-validity-light.svg": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2085;